import { ServerTransactionInBookingType, TRANSACTION_TYPES } from '@expane/data'

export const getBookingHistoryWithoutReferralTransactions = (
  transactions: ServerTransactionInBookingType[],
) =>
  transactions.filter(transaction => transaction.type !== TRANSACTION_TYPES.referralPercentage.id)
